import React, { useEffect, useRef, useState } from 'react';
import BlogSectionHeader from './blog/BlogSectionHeader';
import BlogSectionGrid from './blog/BlogSectionGrid';
import { getSortedPosts } from '@/services/blogService';

const BlogSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => {
      observer.disconnect();
    };
  }, []);

  const featuredPosts = getSortedPosts().slice(0, 3);

  return (
    <section id="blog" className="relative" ref={sectionRef}>
      <div className="blog-vector blog-vector-1"></div>
      <div className="blog-vector blog-vector-2"></div>
      
      <div className="section-container relative z-10">
        <BlogSectionHeader isVisible={isVisible} />
        <BlogSectionGrid
          posts={featuredPosts}
          isVisible={isVisible}
        />
      </div>
    </section>
  );
};

export default BlogSection;
